import dayjs from 'dayjs';

function untilCurYear() {
  let years = [];
  const cur = dayjs().year();

  for (let i = cur - 2; i < cur + 1; i++) {
    years.push(i);
  }

  return years;
}

const constants = {
  MONTHS: [
    { id: 1, name: 'Jan' },
    { id: 2, name: 'Feb' },
    { id: 3, name: 'Mar' },
    { id: 4, name: 'Apr' },
    { id: 5, name: 'May' },
    { id: 6, name: 'Jun' },
    { id: 7, name: 'Jul' },
    { id: 8, name: 'Aug' },
    { id: 9, name: 'Sep' },
    { id: 10, name: 'Oct' },
    { id: 11, name: 'Nov' },
    { id: 12, name: 'Dec' }
  ],
  YEARS: untilCurYear(),
  GENDER: ['Male', 'Female'],
  EMPLOYEE_TYPE: ['Permanent FT', 'Permanent PT', 'Contract FT', 'Contract PT'],
  JOB_CATEGORY: ['Teachers', 'Principal', 'Support Staff', 'HR'],
  ID_TYPE: ['KTP', 'Passport'],
  MARITAL_STATUS: [
    'Single',
    'Married',
    'Divorced',
    'Engaged',
    'Separated',
    'Widowed'
  ],
  RELIGION: ['Christian', 'Catholic', 'Islam', 'Hindu', 'Buddha'],
  BLOOD_TYPE: [
    'A',
    'B',
    'AB',
    'O',
    'A+',
    'A-',
    'O+',
    'O-',
    'B+',
    'B-',
    'AB+',
    'AB-'
  ],
  HIGHEST_EDU: [
    "Bachelor's Degree",
    "Master's Degree",
    'Diploma',
    'Senior High School'
  ],
  DEPARTMENT: ['Preschool', 'Primary', 'Secondary'],
  WAJIB_PAJAK: [
    'K0',
    'K1',
    'K2',
    'K3',
    'TK0',
    'TK1',
    'TK2',
    'TK3',
    'HB0',
    'HB1',
    'HB2',
    'HB3'
  ],
  TIMEOFF_TYPE: [
    'Sickness',
    'Excuse',
    'Early Leave Before 2 PM',
    'Early Leave After 2 PM',
    'Maternity',
    'Special Leave'
  ],
  CALENDAR_EVENT_TYPE: [
    'Public Holiday',
    'School Holiday',
    'Staff Preparation Day',
    'Teachers Preparation Day',
    'Exams',
    'First Day Of School',
    'Special Activities'
  ],
  NAV_PAGES: {
    DASHBOARD: 'Dashboard',
    MY_DETAILS: 'MyDetails',
    MY_PAYSLIPS: 'MyPayslips',
    MY_ATTENDANCE: 'MyAttendance',
    MY_TIMEOFF: 'MyTimeoff',
    STAFF_DETAILS: 'StaffDetails',
    STAFF_PAYSLIPS: 'StaffPayslips',
    STAFF_ATTENDANCE: 'StaffAttendance',
    PENDING_REQUESTS: 'PendingRequests'
  }
};

let regentsUtils = (function() {
  'use strict';

  function isOnTime(profile, clockInTime) {
    let latenessThreshold = latenessThresholdByDepartment(profile.department);
    let fmtClockIn = dayjs(clockInTime).format(
      `YYYY-MM-DD ${latenessThreshold}`
    );
    return dayjs(clockInTime).isBefore(fmtClockIn);
  }

  function latenessThresholdByDepartment(department, clockInTime) {
    let latenessThreshold = '08:01';
    switch (department) {
      case 'Primary':
        let d = dayjs(clockInTime).format('ddd');
        latenessThreshold = d === 'Mon' ? '07:16' : '07:31';
        break;
    }
    return latenessThreshold;
  }

  function countAnnualLateness(jsonArr, department) {
    let countLate = 0;
    jsonArr.forEach(row => {
      let latenessThreshold = '08:01';
      switch (department) {
        case 'Primary':
          let d = dayjs(row.clock_in).format('ddd');
          latenessThreshold = d === 'Mon' ? '07:16' : '07:31';
          break;
      }
      let fmtClockIn = dayjs(row.clock_in).format(
        `YYYY-MM-DD ${latenessThreshold}`
      );
      let isOnTime = dayjs(row.clock_in).isBefore(fmtClockIn);
      if (!isOnTime) {
        countLate++;
      }
    });
    return countLate;
  }

  function countAnnualLatenessTotal(jsonArr, department) {
    let countLate = 0;
    jsonArr.forEach(row => {
      let latenessThreshold = '08:01';
      switch (department) {
        case 'Primary':
          let d = dayjs(row.clock_in).format('ddd');
          latenessThreshold = d === 'Mon' ? '07:16' : '07:31';
          break;
      }
      let fmtClockIn = dayjs(row.clock_in).format(
        `YYYY-MM-DD ${latenessThreshold}`
      );
      let isOnTime = dayjs(row.clock_in).isBefore(fmtClockIn);
      if (!isOnTime) {
        countLate++;
      }
    });
    return countLate;
  }

  // monthly attendance deduction
  function attendanceDeduction(r, countLate) {
    let row = Object.assign({}, r);
    let isExpat = row.is_expat;
    let isSchoolOrPrepDay =
      row.type === 'Teachers Preparation Day' ||
      row.type === 'School Preparation Day';
    row.date = dayjs(row.date).format('ddd, DD MMM YYYY');
    row.t = 'On Time';
    row.deduction = 0;
    if (row.ignore_attendance) {
      row.t = 'Clock In Ignored';
      return row;
    }
    // check
    if (row.timeoff_type) {
      row.t = row.timeoff_type;
      switch (row.timeoff_type) {
        case 'Sickness':
          // with mc, if expat = 50000, local = 30000
          row.deduction = isExpat ? 50000 : 30000;
          break;
        case 'Excuse':
          row.deduction = isExpat ? 500000 : 150000;
          break;
        case 'Early Leave Before 2 PM':
          row.deduction = 75000;
          break;
        case 'Early Leave After 2 PM':
          row.deduction = 50000;
          break;
        default:
          break;
      }
    } else {
      if (row.clock_in === null) {
        // assumed as absent if no clock in and out
        if (row.clock_out === null) {
          row.t = 'Absent';
          row.deduction = isExpat ? 500000 : 150000;
        } else {
          row.t = 'Leave Early After 2 PM';
          row.deduction = 50000;
        }
      } else {
        // if not clocked out, assumed it's leave early after 2 pm
        if (row.clock_out === null) {
          row.t = 'Leave Early After 2 PM';
          row.deduction = 50000;
        } else {
          let latenessThreshold = '08:01';
          switch (row.department) {
            case 'Primary':
              let d = dayjs(row.clock_in).format('ddd');
              if (d === 'Mon') {
                latenessThreshold = '07:16';
              } else {
                latenessThreshold = '07:31';
              }
              break;
          }
          let fmtClockIn = dayjs(row.clock_in).format(
            `YYYY-MM-DD ${latenessThreshold}`
          );
          let isOnTime = dayjs(row.clock_in).isBefore(fmtClockIn);
          if (isOnTime) {
            row.t = 'On Time';
          } else {
            row.t = 'Late';
            row.deduction = 75000;
          }
        }
      }
      // forgive them if count late doesnt exceed yet
      // AND if deduction amount is not set
      if (row.t === 'Late' && countLate <= 10 && r.deduction_amount === 0) {
        console.log(r);
        row.deduction = 0;
      }
      // check if absent during prep days or ijin but not approved
      if (isSchoolOrPrepDay) {
        let sal = row.salary;
        if (row.t === 'Absent' || (row.timeoff_type && !row.is_approved)) {
          row.deduction = sal / 20;
        }
      }
    }
    // override deduction from admin
    if (row.id_deduction) {
      row.deduction = row.deduction_amount;
    }
    if (row.deduction_type) {
      row.t = row.deduction_type;
    }
    // if timeoff and deduction exists, use that deduction
    if (row.timeoff_type && row.deduction_amount !== null) {
      row.deduction = row.deduction_amount;
    }
    // override by admin when late and count late is more than 10
    if (row.t === 'Late' && countLate > 10) {
      row.deduction = row.deduction_amount;
    }

    return row;
  }

  return {
    attendanceDeduction,
    countAnnualLateness,
    countAnnualLatenessTotal,
    latenessThresholdByDepartment,
    isOnTime
  };
})();

export { constants, regentsUtils };
